import { CommonAPIService } from 'src/servicehandlers/CommonHandler';

export class LessonsAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  getAllLessons(router){
    const url = `/api/lessons`
    return this.CommonAPIService.getCall(url, null, router)
  }
  getAllLessonTypes(router){
    const url = `/api/lessons/types`
    return this.CommonAPIService.getCall(url, null, router)
  }

  duplicateLesson(id, router){
    const url = `/api/lessons/duplicate/${id}`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getLessonById(id, router) {
    const url = `/api/lessons/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  createLesson(params, router) {
    const url = `/api/lessons`;
    return this.CommonAPIService.postCall(url, params, router);
  }

  updateLesson(id, params, router) {
    const url = `/api/lessons/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  deleteLesson(id, router) {
    const url = `/api/lessons/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

}
export default LessonsAPIService;
